module.exports = __webpack_public_path__ + "produce-fresh-grass-01.jpg?95f0b3b1ee95ad9604847d8021d71a16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-01.jpg
// module id = 38
// module chunks = 0